import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Login from "../../components/Login";
import ChangeDomain from "../../components/ChangeDomain";
import PasswordReminder from "../../components/PasswordReminder";
import { Icon } from "semantic-ui-react";
import * as AppActions from "../../actions";
import logo from "../../images/informed_logo.png";
import ReactModal from "react-modal";

class LoginContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forgotPassword: false,
      changeDomain: false,
      testServer: this.props.test ? "Test" : "Production"
    };

    var subdomain = window.location.host.split(".")[0];

    if (this.props.isLoggedIn) {
      this.direct();
    }

    this.tablet = window.innerWidth - 40 < 550 ? false : true;
  }

  handleForgotPassword(e) {
    this.props.actions.setResetPassword(0);
    this.setState({ forgotPassword: true });
  }

  handleClose() {
    this.props.actions.setResetPassword(0);
    this.setState({ forgotPassword: false });
  }

  handleResetPassword(email) {
    this.props.actions.resetPassword(email);
  }

  renderControl() {
    const {
      isLoading,
      loginError,
      errorMessage,
      authenticated,
      isLoggedIn,
      isConnected,
      resetPassword
    } = this.props;

    if (this.state.forgotPassword) {
      return (
        <PasswordReminder
          onBack={this.handleClose.bind(this)}
          status={resetPassword}
          isConnected={isConnected}
          onPasswordReminder={this.handleResetPassword.bind(this)}
        />
      );
    }

    return (
      <Login
        onConfig={this.handleConfig.bind(this)}
        isLoggedOut={this.props.isLoggedOut}
        isLoading={isLoading}
        onForgotPassword={this.handleForgotPassword.bind(this)}
        isConnected={isConnected}
        isLoggedIn={isLoggedIn}
        authenticated={authenticated}
        errorMessage={errorMessage}
        error={loginError}
        onLogin={this.handleLogin.bind(this)}
      />
    );
  }

  handleConfig() {
    this.setState({ changeDomain: true });
  }

  renderClose() {
    if (this.state.forgotPassword) {
      return (
        <Icon
          type="MaterialIcons"
          onClick={this.handleClose.bind(this)}
          style={{
            top: 20,
            right: 20,
            position: "absolute",
            color: "rgb(232, 232, 232)",
            cursor: "pointer"
          }}
          size="large"
          name="close"
        />
      );
    }
  }

  direct() {
    if (this.props.isLoggedIn) {
      this.props.actions.reset();
      this.props.history.push("/forms");
    }
  }

  handleLogin(username, password) {
    let isTest = this.state.testServer === "Test";
    this.props.actions.setApi(isTest);

    this.props.actions
      .validateUser(username, password, this.props.deviceId)
      .then(() => this.direct());
  }

  handleCloseChangeDomain() {
    this.setState({ changeDomain: false });
  }

  handleChangeDomain(value) {
    this.setState({ testServer: value, changeDomain: false });
  }

  renderChangeDomain() {
    return (
      <ReactModal
        isOpen={this.state.changeDomain}
        style={customStylesRename}
        contentLabel="ChangeDomain"
        onRequestClose={() => {
          //alert('Modal has been closed.');
        }}
      >
        <div
          style={{
            paddingTop: 40,
            backgroundColor: "white",
            paddingLeft: 0,
            paddingRight: 0,
            borderRadius: 6,
            width: "100%",
            height: "100%"
          }}
        >
          <Icon
            type="MaterialIcons"
            onClick={this.handleCloseChangeDomain.bind(this)}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              color: "#e6e6e6",
              cursor: "pointer"
            }}
            size="large"
            name="close"
          />
          <ChangeDomain
            testServer={this.state.testServer}
            tablet={this.tablet}
            onChangeDomain={this.handleChangeDomain.bind(this)}
          />
        </div>
      </ReactModal>
    );
  }

  render() {
    let bgcolor = "linear-gradient(#458CCA,#3C78AD)";

    let textColor = "#fff";

    let colorLight = "#dcecf7";

    if (this.tablet) {
      return (
        <div style={{ height: "100vh", overflowY: "auto" }}>
          {this.renderChangeDomain()}
          <div
            style={{
              minHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              background: bgcolor
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <div style={{}}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    width: "100%",
                    margin: "125px auto 0",
                    maxWidth: "600px",
                    color: textColor
                  }}
                >
                  <div style={{ display: "block", marginTop: 0 }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          marginBottom: 35,
                          textAlign: "center",
                          width: 400,
                          marginLeft: "72.25px",
                          paddingLeft: 40
                        }}
                      >
                        <img
                          src="https://www.in-formed.co.uk/catalog/view/theme/default/images/new-logo.png"
                          alt=""
                        ></img>
                      </div>
                    </div>
                    {this.renderControl()}
                    <div style={{ height: 80 }}>&nbsp;</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                padding: "0 100px",
                fontSize: 11,
                textAlign: "right",
                margin: "35px 0",
                color: colorLight
              }}
            >
              InFormed Software Limited. Registered in England and Wales,
              company number 8607055
            </div>
            <div style={{ height: 20 }}>&nbsp;</div>
          </div>
        </div>
      );
    }

    return (
      <div className="ui form" style={{ paddingTop: "0px" }}>
        <table
          cellPadding="0"
          cellSpacing="0"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: "280px",
            position: "relative",
            top: "0px"
          }}
        >
          <tbody>
            <tr>
              <td style={{ align: "center" }}>
                <div
                  style={{
                    position: "relative",
                    maxWidth: "280px",
                    borderRadius: "5px",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    height: "520px",
                    backgroundColor: "white"
                  }}
                >
                  <img
                    src={logo}
                    height="93px"
                    style={{ top: "-.5px", position: "relative", left: "0px" }}
                  />
                  {this.renderClose()}
                  {this.renderControl()}
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="3" style={{ textAlign: "center", fontSize: "11px" }}>
                <br />
                <a
                  style={{ color: "#bbb" }}
                  href="http://www.informed.software"
                >
                  Informed Software Limited
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

LoginContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loginError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isLoggedOut: PropTypes.bool.isRequired,
  sessionId: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
};

const customStylesRename = {
  content: {
    top: "50%",
    width: "85%",
    maxWidth: "320px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0px;",
    borderRadius: "5px",
    border: "0px",
    height: "190px",
    backgroundColor: "#fff",
    transform: "translate(-50%, -50%)"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  }
};

const mapStateToProps = state => ({
  isLoggedIn: state.informedWebApp.sessionId === "" ? false : true,
  sessionId: state.informedWebApp.sessionId,
  loginError: state.informedWebApp.loginError,
  isLoggedOut: state.informedWebApp.isLoggedOut,
  errorMessage: state.informedWebApp.errorMessage,
  deviceId: state.informedWebApp.deviceId,
  test: state.informedWebApp.api.indexOf("test") === -1 ? false : true,
  isAuthenticated: state.informedWebApp.authenticated === "" ? false : true,
  isLoading: state.informedWebApp.isLoading,
  isConnected: state.informedWebApp.isConnected,
  resetPassword: state.informedWebApp.resetPassword
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginContainer)
);

//export default Login;



// WEBPACK FOOTER //
// ./src/containers/LoginContainer/index.js